// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    MessageLinkEntity,
    MessageLinkEntityFromJSON,
    MessageLinkEntityToJSON,
} from './';

/**
 * 
 * @export
 * @interface MessageLinks
 */
export interface MessageLinks {
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    messageCategories?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    users?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    messages?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    claims?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    facilities?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    patients?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    payers?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    payments?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    transmissions?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    providers?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    subscribers?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    userDocumentItems?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    mails?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    letterSendRecords?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    faxReceiveRecords?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    faxSendRecords?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    guarantors?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    codings?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    phones?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    emailSendRecords?: Array<MessageLinkEntity>;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<MessageLinkEntity>}
     * @memberof MessageLinks
     */
    collectionPayments?: Array<MessageLinkEntity>;
}

export function MessageLinksFromJSON(json: any): MessageLinks {
    return {
            'messageCategories': !exists(json, 'messageCategories') ? undefined : (json['messageCategories'] as Array<any>).map(MessageLinkEntityFromJSON),
            'users': !exists(json, 'users') ? undefined : (json['users'] as Array<any>).map(MessageLinkEntityFromJSON),
            'messages': !exists(json, 'messages') ? undefined : (json['messages'] as Array<any>).map(MessageLinkEntityFromJSON),
            'claims': !exists(json, 'claims') ? undefined : (json['claims'] as Array<any>).map(MessageLinkEntityFromJSON),
            'facilities': !exists(json, 'facilities') ? undefined : (json['facilities'] as Array<any>).map(MessageLinkEntityFromJSON),
            'patients': !exists(json, 'patients') ? undefined : (json['patients'] as Array<any>).map(MessageLinkEntityFromJSON),
            'payers': !exists(json, 'payers') ? undefined : (json['payers'] as Array<any>).map(MessageLinkEntityFromJSON),
            'payments': !exists(json, 'payments') ? undefined : (json['payments'] as Array<any>).map(MessageLinkEntityFromJSON),
            'transmissions': !exists(json, 'transmissions') ? undefined : (json['transmissions'] as Array<any>).map(MessageLinkEntityFromJSON),
            'providers': !exists(json, 'providers') ? undefined : (json['providers'] as Array<any>).map(MessageLinkEntityFromJSON),
            'subscribers': !exists(json, 'subscribers') ? undefined : (json['subscribers'] as Array<any>).map(MessageLinkEntityFromJSON),
            'userDocumentItems': !exists(json, 'userDocumentItems') ? undefined : (json['userDocumentItems'] as Array<any>).map(MessageLinkEntityFromJSON),
            'mails': !exists(json, 'mails') ? undefined : (json['mails'] as Array<any>).map(MessageLinkEntityFromJSON),
            'letterSendRecords': !exists(json, 'letterSendRecords') ? undefined : (json['letterSendRecords'] as Array<any>).map(MessageLinkEntityFromJSON),
            'faxReceiveRecords': !exists(json, 'faxReceiveRecords') ? undefined : (json['faxReceiveRecords'] as Array<any>).map(MessageLinkEntityFromJSON),
            'faxSendRecords': !exists(json, 'faxSendRecords') ? undefined : (json['faxSendRecords'] as Array<any>).map(MessageLinkEntityFromJSON),
            'guarantors': !exists(json, 'guarantors') ? undefined : (json['guarantors'] as Array<any>).map(MessageLinkEntityFromJSON),
            'codings': !exists(json, 'codings') ? undefined : (json['codings'] as Array<any>).map(MessageLinkEntityFromJSON),
            'phones': !exists(json, 'phones') ? undefined : (json['phones'] as Array<any>).map(MessageLinkEntityFromJSON),
            'emailSendRecords': !exists(json, 'emailSendRecords') ? undefined : (json['emailSendRecords'] as Array<any>).map(MessageLinkEntityFromJSON),
            'collectionPayments': !exists(json, 'collectionPayments') ? undefined : (json['collectionPayments'] as Array<any>).map(MessageLinkEntityFromJSON),
    };

}

export function MessageLinksToForm(value?: MessageLinks): any {
    let jsonVal = MessageLinksToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function MessageLinksToJSON(value?: MessageLinks): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'messageCategories': (value.messageCategories === undefined || value.messageCategories === null) ? undefined : (value.messageCategories as Array<any>).map(MessageLinkEntityToJSON),
            'users': (value.users === undefined || value.users === null) ? undefined : (value.users as Array<any>).map(MessageLinkEntityToJSON),
            'messages': (value.messages === undefined || value.messages === null) ? undefined : (value.messages as Array<any>).map(MessageLinkEntityToJSON),
            'claims': (value.claims === undefined || value.claims === null) ? undefined : (value.claims as Array<any>).map(MessageLinkEntityToJSON),
            'facilities': (value.facilities === undefined || value.facilities === null) ? undefined : (value.facilities as Array<any>).map(MessageLinkEntityToJSON),
            'patients': (value.patients === undefined || value.patients === null) ? undefined : (value.patients as Array<any>).map(MessageLinkEntityToJSON),
            'payers': (value.payers === undefined || value.payers === null) ? undefined : (value.payers as Array<any>).map(MessageLinkEntityToJSON),
            'payments': (value.payments === undefined || value.payments === null) ? undefined : (value.payments as Array<any>).map(MessageLinkEntityToJSON),
            'transmissions': (value.transmissions === undefined || value.transmissions === null) ? undefined : (value.transmissions as Array<any>).map(MessageLinkEntityToJSON),
            'providers': (value.providers === undefined || value.providers === null) ? undefined : (value.providers as Array<any>).map(MessageLinkEntityToJSON),
            'subscribers': (value.subscribers === undefined || value.subscribers === null) ? undefined : (value.subscribers as Array<any>).map(MessageLinkEntityToJSON),
            'userDocumentItems': (value.userDocumentItems === undefined || value.userDocumentItems === null) ? undefined : (value.userDocumentItems as Array<any>).map(MessageLinkEntityToJSON),
            'mails': (value.mails === undefined || value.mails === null) ? undefined : (value.mails as Array<any>).map(MessageLinkEntityToJSON),
            'letterSendRecords': (value.letterSendRecords === undefined || value.letterSendRecords === null) ? undefined : (value.letterSendRecords as Array<any>).map(MessageLinkEntityToJSON),
            'faxReceiveRecords': (value.faxReceiveRecords === undefined || value.faxReceiveRecords === null) ? undefined : (value.faxReceiveRecords as Array<any>).map(MessageLinkEntityToJSON),
            'faxSendRecords': (value.faxSendRecords === undefined || value.faxSendRecords === null) ? undefined : (value.faxSendRecords as Array<any>).map(MessageLinkEntityToJSON),
            'guarantors': (value.guarantors === undefined || value.guarantors === null) ? undefined : (value.guarantors as Array<any>).map(MessageLinkEntityToJSON),
            'codings': (value.codings === undefined || value.codings === null) ? undefined : (value.codings as Array<any>).map(MessageLinkEntityToJSON),
            'phones': (value.phones === undefined || value.phones === null) ? undefined : (value.phones as Array<any>).map(MessageLinkEntityToJSON),
            'emailSendRecords': (value.emailSendRecords === undefined || value.emailSendRecords === null) ? undefined : (value.emailSendRecords as Array<any>).map(MessageLinkEntityToJSON),
            'collectionPayments': (value.collectionPayments === undefined || value.collectionPayments === null) ? undefined : (value.collectionPayments as Array<any>).map(MessageLinkEntityToJSON),
    };
}


